module.exports = __webpack_public_path__ + "static/media/MA.de39388f.svg";